/**
 * @Author: Sindre Svee
 * @Date:   20.05.2021
 * @Email:  sindre@sindresvee.no
 * @Project: Event-OS
 * @Last modified by:   Sindre Svee
 * @Last modified time: 20.05.2021
 * @Copyright: Copyright (c) Sindre Svee
 */

// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: 'eventOS',
    appLogoImage: require('@src/assets/images/logo/logo.svg').default
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: true,
      isCollapsed: true
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'hidden', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    maintenance: false,
    customizer: false,
    overrideMode: 'no', // Override current site mode  show, lfmk, noevent, no
    hideCrewModule: false, // Override hides crew module
    hideCrewPhone: false, // Override hides crew phone on module
    hideCrewEmail: false, // Override hides crew email on module
    hideTicketModule: false, // Override hides ticket module
    hideStatusModule: false, // Override hides status module
    hideNextEvent: false, // Override hides next event module when in show mode
    hideHeaderModule: false, // Override hides next event module when in show mode
    scrollTop: true // Enable scroll to top button
  }
}

export default themeConfig
